import { useLiveQuery } from 'dexie-react-hooks';

import db from '../lib/db';

import { useOptionalRouteWorkspace } from '../contexts/RouteWorkspaceContext';

// Fills in a partial profile (e.g. a message author snapshot) from Dexie so popover
// anchors show current name/tag data. A profile that already carries its
// direct_message_key is fully hydrated, so the lookup is skipped for it.
const useResolvedProfile = (profile, enabled = true) => {
  const routeWorkspace = useOptionalRouteWorkspace();
  const workspaceId = routeWorkspace?.workspaceId;
  const shouldLoadProfile = enabled && profile?.id && !profile?.direct_message_key && !!workspaceId;
  const fullProfile = useLiveQuery(
    () => (shouldLoadProfile ? db.profiles.get([workspaceId, profile.id]) : null),
    [profile?.direct_message_key, profile?.id, shouldLoadProfile, workspaceId],
    null,
  );
  return fullProfile ?? profile;
};

export default useResolvedProfile;
